import { api, baseURL } from '../../shared/api/client';
import { putWithProgress } from '../../shared/lib/upload';

export type SoftwarePlatform = 'windows' | 'macos';

/** Программа для просмотра снимков (Romexis) — актуальная версия для платформы. */
export interface SoftwareDownload {
  platform: SoftwarePlatform;
  platformLabel: string;
  title: string;
  version: string;
  fileName: string;
  size: number;
  updatedAt: string;
}

export const SOFTWARE_PLATFORMS: { id: SoftwarePlatform; label: string; accept: string }[] = [
  { id: 'windows', label: 'Windows', accept: '.exe,.msi,.zip' },
  { id: 'macos', label: 'macOS', accept: '.dmg,.pkg,.zip' },
];

export const softwareQueryKey = ['software'] as const;

/** Список загруженных программ (публично, без авторизации). */
export async function listSoftware(): Promise<SoftwareDownload[]> {
  const { data } = await api.get<{ items: SoftwareDownload[] }>('/v1/public/software');
  return data.items;
}

/** Прямая ссылка на скачивание: API редиректит на файл в хранилище. */
export function softwareDownloadUrl(platform: SoftwarePlatform): string {
  return `${baseURL}/v1/public/software/${platform}/download`;
}

interface StartUploadResponse {
  key: string;
  fileName: string;
  uploadUrl: string;
  uploadMethod: 'PUT';
}

/** Загрузка установщика администратором: presigned PUT → S3 → complete. */
export async function uploadSoftware(
  platform: SoftwarePlatform,
  file: File,
  version: string,
  onProgress: (fraction: number) => void,
): Promise<SoftwareDownload> {
  const contentType = file.type || 'application/octet-stream';
  const { data } = await api.post<StartUploadResponse>(`/v1/admin/software/${platform}/upload`, {
    fileName: file.name,
    contentType,
  });
  await putWithProgress(data.uploadUrl, file, contentType, onProgress);
  const { data: saved } = await api.post<SoftwareDownload>(
    `/v1/admin/software/${platform}/complete`,
    {
      key: data.key,
      fileName: data.fileName,
      version,
    },
  );
  return saved;
}

export async function deleteSoftware(platform: SoftwarePlatform): Promise<void> {
  await api.delete(`/v1/admin/software/${platform}`);
}
